import { login, getMenus, logout } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  name: '',
  roles: [],
  menus: []
}

const mutations = {
  SET_TOKEN: (state, token) => { state.token = token },
  SET_NAME: (state, name) => { state.name = name },
  SET_ROLES: (state, roles) => { state.roles = roles },
  SET_MENUS: (state, menus) => { state.menus = menus }
}

const getters = {
  token: state => state.token,
  roles: state => state.roles,
  menus: state => state.menus,
  name: state => state.name
}

const actions = {
  login({ commit }, userInfo) {
    return login(userInfo).then(res => {
      const token = res.data.token
      commit('SET_TOKEN', token)
      setToken(token)
    })
  },

  getInfo({ commit }) {
    return getMenus().then(res => {
      const menus = res.data
      const permissions = extractPermissions(menus)
      localStorage.setItem('perms', JSON.stringify(permissions))
      commit('SET_MENUS', menus)
      commit('SET_ROLES', permissions)
      commit('SET_NAME', 'Admin')
    })
  },

  logout({ commit }) {
    commit('SET_TOKEN', '')
    commit('SET_ROLES', [])
    removeToken()
  }
}

function extractPermissions(menus, perms = []) {
  if (!menus) return perms
  for (const m of menus) {
    if (m.permissionCode) perms.push(m.permissionCode)
    if (m.children) extractPermissions(m.children, perms)
  }
  return perms
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
